import { useEffect } from 'react'

const APP_NAME = 'Indlus'

/** Título do separador do browser: "Cobranças · Deco Residence · Indlus". */
export function useDocumentTitle(...parts: (string | null | undefined | false)[]) {
  const title = [...parts.filter(Boolean), APP_NAME].join(' · ')
  useEffect(() => {
    document.title = title
  }, [title])
}
